import { render, staticRenderFns } from "./FormPrivacyLgpd.vue?vue&type=template&id=ed9a2074&"
import script from "./FormPrivacyLgpd.vue?vue&type=script&lang=js&"
export * from "./FormPrivacyLgpd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed9a2074')) {
      api.createRecord('ed9a2074', component.options)
    } else {
      api.reload('ed9a2074', component.options)
    }
    module.hot.accept("./FormPrivacyLgpd.vue?vue&type=template&id=ed9a2074&", function () {
      api.rerender('ed9a2074', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/lgpd/handling/FormPrivacyLgpd.vue"
export default component.exports